import React from 'react';
import cn from 'clsx';

import ProductFlags from '../../../../components/product-flags/product-flags';

import {
  BundleData,
  ProductData
} from '../../../../shared/types/graphql-types';

import styles from './product-list-card-highlight.scss';

interface ProductListCardHighlightProps {
  hideFeaturedAndExclusive?: boolean;
  hideLabel?: boolean;
  hideTreadwellRank?: boolean;
  hideWebOnly?: boolean;
  prebuiltPackage?: BundleData;
  product?: ProductData;
}

function ProductListCardHighlight(props: ProductListCardHighlightProps) {
  const {
    hideFeaturedAndExclusive,
    hideLabel = false,
    hideTreadwellRank = false,
    hideWebOnly = false,
    prebuiltPackage,
    product
  } = props;

  return (
    <div className={cn(styles['container'], 'product-list-card-highlight')}>
      <div
        className={cn(
          styles['product-flags'],
          'product-list-card-highlight__product-flags-container'
        )}
      >
        <ProductFlags
          className="product-list-card-highlight__product-flags"
          hideFeaturedAndExclusive={hideFeaturedAndExclusive}
          hideLabel={hideLabel}
          hideTreadwellRank={hideTreadwellRank}
          hideWebOnly={hideWebOnly}
          prebuiltPackage={prebuiltPackage}
          product={product}
        />
      </div>
    </div>
  );
}

export default ProductListCardHighlight;
